import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { LoadingOverlay } from "cayo.ui";
import { CenteredPanel } from "@cayo/shared/components/CommonLayout";
import { commonMessages } from "@cayo/shared/messages/common";

type HtmlPageProps = {
  filePath: string; // e.g., "/static/my-page.html"
};

const HtmlPage: FC<HtmlPageProps> = ({ filePath }) => {
  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const intl = useIntl();

  useEffect(() => {
    fetch(filePath)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to fetch: ${res.status}`);
        }
        return res.text();
      })
      .then(setHtml)
      .catch((err) => setError(err.message));
  }, [filePath]);

  if (error) {
    return (
      <CenteredPanel>{intl.formatMessage(commonMessages.loadHtmlError, { error })}</CenteredPanel>
    );
  }

  if (html === null) {
    return <LoadingOverlay />;
  }

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default HtmlPage;
